// router.js
import ExercisePlan from "@pages/ExercisePlan";
import Dashboard from "@pages/Dashboard";
import DietPlan from "@pages/DietPlan";
import ProgressTracker from "@pages/ProgressTracker";
import FitbotSupport from "@pages/FitbotSupport";
import Settings from "@pages/Settings";
import ViewProfile from "@components/common/Modals/ViewProfile";
import InviteMembers from "@components/common/Modals/InviteMembers";
import Preferences from "@pages/editPreferences";
import WeeklyMealPlanner from "@features/diet/WeeklyMealPlaner";
import AdviseMe from "@pages/AdviseMe";
import WeeklyMealSelection from "@features/diet/WeeklyMealSelection";
import PreferencesSelection from "@features/diet/PreferenceSelection";
import MealDescriptionModal from "@features/diet/RecipieDetails";
import WeeklyExerciseDetails from "@features/diet/WeeklyExerciseDetails";
import ViewPlan from "@features/diet/WeeklyExerciseDetails/ViewPlan";
import SleepCoach from "@pages/SleepCoach";
import Mindfullness from "@pages/Mindfullness";
import SleepCoachDashboard from "@features/sleep/SleepCoachDashboard";
import MindfulnessDashboard from "@features/mindfulness/MindfulnessDashboard";
import SubscribtionSuspended from "@components/ui/SubscribtionSuspended";
import SleepCoachPreferencesSelection from "@features/sleep/sleepCoachPreferences";
import MindfulnessPreferences from "@features/mindfulness/MindfulnessPreferences";
import QuizGameDashboard from "@pages/QuizGame/Dashboard";
import StartQuizGame from "@features/QuizGame/StartQuizGame";
import AllRanks from "@features/QuizGame/AllRanks";
import WeeklyLeaderBoard from "@features/QuizGame/WeeklyLeaderBoard";
import QuizQuestionaire from "@features/QuizGame/QuizQuestionares";
import ChallengeFinished from "@features/QuizGame/ChallengeFinshed";
import WeeklyProgressTracker from "@pages/WeeklyProgressTracking";
import RanksWeekly from "@features/weeklyProgressTracking/RanksWeekly";
import MotivationCoach from "@pages/MotivationalCoach";
import Contact from "@pages/ContactUs/Contact";
import MedicalViewModal from "@components/common/Modals/MedicalViewModal";
export const routes = [
  {
    path: "/",
    component: Dashboard,
    activeCheck: true,
  },

  {
    path: "/first-forms",
    component: MedicalViewModal,
    activeCheck: true,
  },

  {
    path: "/dashboard/recipe-detail",
    component: MealDescriptionModal,
    activeCheck: true,
  },
  {
    path: "/diet-plan",
    component: DietPlan,
    activeCheck: true,
  },
  {
    path: "/diet-plan/weekly-meal-planner",
    component: WeeklyMealPlanner,
    activeCheck: true,
  },
  {
    path: "/diet-plan/select-meals",
    component: WeeklyMealSelection,
    activeCheck: true,
  },
  {
    path: "/diet-plan/preferences",
    component: PreferencesSelection,
    activeCheck: true,
  },
  {
    path: "/diet-plan/recipe-detail",
    component: MealDescriptionModal,
    activeCheck: true,
  },
  {
    path: "/exercise-plan",
    component: ExercisePlan,
    activeCheck: true,
  },
  {
    path: "/exercise-plan/execise-details",
    component: WeeklyExerciseDetails,
    activeCheck: true,
  },
  {
    path: "/exercise-plan/view-plan",
    component: ViewPlan,
    activeCheck: true,
  },
  {
    path: "/edit-preferences",
    component: Preferences,
    activeCheck: true,
  },
  {
    path: "/advise",
    component: AdviseMe,
    activeCheck: true,
  },
  // {
  //   path: "/progress-tracker",
  //   component: ProgressTracker,
  //   activeCheck: true,
  // },
  {
    path: "/progress-tracker",
    component: WeeklyProgressTracker,
    activeCheck: true,
  },
  {
    path: "/progress-tracker/ranks",
    component: RanksWeekly,
    activeCheck: true,
  },

  // {
  //   path: "/progress-tracker/ranks",
  //   component: AllRanks,
  //   activeCheck: true,
  // },
  // {
  //   path: "/progress-tracker/weekly-Leader-board",
  //   component: WeeklyLeaderBoard,
  //   activeCheck: true,
  // },
  {
    path: "/fitbot-support",
    component: FitbotSupport,
    activeCheck: true,
  },
  {
    path: "/sleep-coach",
    component: SleepCoach,
    activeCheck: true,
  },
  {
    path: "/sleep-coach-dashboard",
    component: SleepCoachDashboard,
    activeCheck: true,
  },
  {
    path: "/sleep-coach-preferences",
    component: SleepCoachPreferencesSelection,
    activeCheck: true,
  },
  {
    path: "/mindfulness",
    component: Mindfullness,
    activeCheck: true,
  },
  {
    path: "/quiz-game/start-quiz",
    component: StartQuizGame,
    activeCheck: true,
  },
  {
    path: "/quiz-game",
    component: QuizGameDashboard,
    activeCheck: true,
  },

  {
    path: "/quiz-game/ranks",
    component: AllRanks,
    activeCheck: true,
  },
  {
    path: "/quiz-game/weekly-Leader-board",
    component: WeeklyLeaderBoard,
    activeCheck: true,
  },
  {
    path: "/quiz-game/questionaires",
    component: QuizQuestionaire,
    activeCheck: true,
  },
  {
    path: "/quiz-game/challenge-finished",
    component: ChallengeFinished,
    activeCheck: true,
  },
  {
    path: "/motivational-coach",
    component: MotivationCoach,
    activeCheck: true,
  },
  {
    path: "/mindfulness-dashboard",
    component: MindfulnessDashboard,
    activeCheck: true,
  },
  {
    path: "/renew-subscription",
    component: SubscribtionSuspended,
  },
  {
    path: "/mindfulness-preferences",
    component: MindfulnessPreferences,
    activeCheck: true,
  },

  {
    path: "/contact-us",
    component: Contact,
    // activeCheck: true,
  },

  // {
  //   path: "/view-profile",
  //   component: ViewProfile,
  // },
  {
    path: "/invite-member",
    component: InviteMembers,
  },
  {
    path: "/settings",
    component: Settings,
  },
];
